import { useState } from "react";

export default function ModulePlan({ module }) {
  const planStages = module?.planStages;
  const totalStages = planStages?.length || 1;
  const useFullWidthGanttBars = Boolean(module?.fullWidthGanttBars);
  const [expandedStages, setExpandedStages] = useState({});

  const toggleStage = (stageName) => {
    setExpandedStages((prev) => ({
      ...prev,
      [stageName]: !prev[stageName],
    }));
  };

  return (
    <section
      className="module-plan"
      aria-label={`${module?.title || "Module"} plan`}
    >
      <p className="module-plan__intro">
        Planned rollout path for {module?.title || "this module"}.
      </p>

      <ol className="module-plan__list">
        {planStages?.map((stage, index) => {
          const startPercent = useFullWidthGanttBars
            ? 0
            : (index / totalStages) * 100;
          const endPercent = useFullWidthGanttBars
            ? 100
            : ((index + 1) / totalStages) * 100;
          const isExpanded = Boolean(expandedStages[stage.name]);
          const detailId = `module-plan-detail-${module?.key || "module"}-${index}`;
          const hasDetail = Array.isArray(stage.detail)
            ? stage.detail.length > 0
            : Boolean(stage.detail);

          return (
            <li key={stage.name} className="module-plan__item">
              <div className="module-plan__item-head">
                <h4>{stage.name}</h4>
                <div className="module-plan__item-controls">
                  <span className="module-plan__item-window">
                    {stage.completionDate || "TBC"}
                  </span>

                  {hasDetail && (
                    <button
                      className="module-plan__toggle"
                      type="button"
                      onClick={() => toggleStage(stage.name)}
                      aria-expanded={isExpanded}
                      aria-controls={detailId}
                    >
                      {isExpanded ? "Hide" : "Expand"}
                    </button>
                  )}
                </div>
              </div>

              <div className="module-plan__gantt-line" aria-hidden="true">
                <span
                  className="module-plan__gantt-bar"
                  style={{
                    "--gantt-start": `${startPercent}%`,
                    "--gantt-width": `${endPercent - startPercent}%`,
                  }}
                />
              </div>

              {isExpanded &&
                hasDetail &&
                (Array.isArray(stage.detail) ? (
                  <ul className="module-plan__detail-list" id={detailId}>
                    {stage.detail.map((detailPoint, detailIndex) => {
                      const normalizedDetail =
                        typeof detailPoint === "string"
                          ? {
                              text: detailPoint,
                              checked: detailPoint
                                .trimStart()
                                .startsWith("[x]"),
                            }
                          : detailPoint;

                      const detailText = String(normalizedDetail?.text || "")
                        .replace(/^\[x\]\s*/i, "")
                        .trim();

                      return (
                        <li
                          key={`${stage.name}-${detailIndex}-${detailText}`}
                          className={
                            normalizedDetail?.checked
                              ? "module-plan__detail-item module-plan__detail-item--checked"
                              : "module-plan__detail-item"
                          }
                        >
                          {normalizedDetail?.checked && (
                            <span
                              className="module-plan__detail-tick"
                              aria-hidden="true"
                            >
                              ✓
                            </span>
                          )}
                          <span>{detailText}</span>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <p id={detailId}>{stage.detail}</p>
                ))}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
